// src/components/NotificationSyncWatcher.jsx
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import { useAuth } from '../contexts/AuthContext';

export default function NotificationSyncWatcher() {
  const location = useLocation();
  const { user } = useAuth();

  useEffect(() => {
    if (!user?.id) return;

    const syncRouteNotifications = async () => {
      // Normalize path to match trailing slashes or exact string entries
      const currentPath = location.pathname;

      try {
        // Find unread notifications for this user that point to the exact page they just landed on
        const { data: matchingNotifications } = await supabase
          .from('notifications')
          .select('id')
          .eq('target_user_id', user.id)
          .eq('status', 'unread')
          .eq('redirect_url', currentPath);

        if (matchingNotifications && matchingNotifications.length > 0) {
          const idsToUpdate = matchingNotifications.map(n => n.id);

          // Batch update them all to read instantly
          await supabase
            .from('notifications')
            .update({ status: 'read' })
            .in('id', idsToUpdate);
            
          console.log(`Successfully synced ${idsToUpdate.length} notification states for path: ${currentPath}`);
        }
      } catch (err) {
        console.error('Failed to sync incoming location notifications:', err.message);
      }
    };

    syncRouteNotifications();
  }, [location.pathname, user?.id]);

  return null; // Invisible structural component
}